import { render, staticRenderFns } from "./OrganizationTabAcademy.vue?vue&type=template&id=81f89eac&scoped=true"
import script from "./OrganizationTabAcademy.vue?vue&type=script&lang=js"
export * from "./OrganizationTabAcademy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f89eac",
  null
  
)

export default component.exports